// pdfmake 0.2.x builds the PDF inside its own promise with no error handler. If the
// build fails -- a malformed signature or logo image, say -- the error never reaches
// pdfmake's callback, and nothing the caller wraps it in (try/catch, .catch) can see
// it: the callback just never fires. Anything waiting on that callback, such as a
// full-screen "Downloading..." popup or a busy flag, would then wait forever.
//
// So run each pdfmake call against a time limit and settle on whichever comes first.
// A callback that arrives after the limit is ignored. The limit is generous: a large
// PDF with many photos can take well over 20 seconds on a slow machine, and a build
// that is only slow must not be reported as failed.
export const PDF_TIME_LIMIT_MS = 90000

export const PDF_FAILED_MESSAGE = "Couldn't create the PDF. Please try again."

export function runPdf(start, timeLimitMs = PDF_TIME_LIMIT_MS) {
    return new Promise((resolve, reject) => {
        let settled = false
        let timer = null
        const finish = (settle, value) => {
            if (settled) return
            settled = true
            clearTimeout(timer)
            settle(value)
        }
        timer = setTimeout(() => finish(reject, new Error(PDF_FAILED_MESSAGE)), timeLimitMs)
        try {
            start(result => finish(resolve, result))
        } catch (error) {
            // Errors thrown before pdfmake hands off to its promise are catchable here.
            finish(reject, error)
        }
    })
}
